import axios, { AxiosRequestConfig } from 'axios';

import { IConfig } from './config';

const adapter = axios.defaults.adapter;

async function request(req: AxiosRequestConfig, config: IConfig) {
  config.debug('handle request', req);
  const shouldCache = config.path.includes(req.url!) && !config.skip;
  const key = config.key(req);

  if (shouldCache) {
    const res = config.cache.get(key);
    if (res) {
      config.debug('cache hit for', req.url);
      return res;
    }
    config.debug('cache miss for', req.url);
  }
  const res = await adapter!(req);
  if (shouldCache && res.status === 200) {
    config.cache.set(key, res);
    config.debug('set cache for', req.url, res);
  }
  return res;
}

export default request;
